import {
  ComponentConfigurationType,
  ComponentType,
  CreateDevice,
  CreateSubComponent,
  SubComponentConfigurationType,
  SubComponentType,
} from "@models";
import { CreateComponentBase, CreateDeviceUiState } from "@types";

// Also at least one component is required
export const isFormInvalid = (newDevice: CreateDeviceUiState) =>
  !newDevice.name ||
  !newDevice.description ||
  newDevice.components.some((c) => !c.name || !c.description) ||
  newDevice.components.some((c) =>
    c.subComponents?.some((sc) => !sc.description)
  ) ||
  newDevice.components.length === 0;

export const newProductInitialState: CreateDeviceUiState = {
  name: "",
  description: "",
  isIVDR: false,
  isFDA: false,
  isMDR: false,
  components: [],
};

export const newSoftwareComponentInitialState: CreateComponentBase = {
  type: ComponentType.SOFTWARE,
  name: "",
  description: "",
  configuration: [
    {
      type: ComponentConfigurationType.HAS_AI,
      value: "false",
    },
  ],
};

export const initialSoftwareSubComponentState: CreateSubComponent = {
  type: SubComponentType.SOFTWARE,
  name: "",
  description: "",
  configuration: [
    {
      type: SubComponentConfigurationType.HAS_AI,
      value: "false",
    },
  ],
};

export const initialElectricalSubComponentState: CreateSubComponent = {
  type: SubComponentType.ELECTRICAL,
  name: "",
  description: "",
  configuration: [
    {
      type: SubComponentConfigurationType.IS_IMPLANTABLE,
      value: "false",
    },
  ],
};

export const newHardwareComponentInitialState: CreateComponentBase = {
  type: ComponentType.HARDWARE,
  name: "",
  description: "",
  configuration: [
    {
      type: ComponentConfigurationType.IS_IMPLANTABLE,
      value: "false",
    },
    {
      type: ComponentConfigurationType.IS_STERILIZATION_INTENDED,
      value: "false",
    },
    {
      type: ComponentConfigurationType.HAS_HUMAN_CONTACT,
      value: "false",
    },
  ],
};

export const getCleanDevice = (
  newDevice: CreateDeviceUiState
): CreateDevice => ({
  name: newDevice.name,
  description: newDevice.description,
  isMDR: newDevice.isMDR,
  isFDA: newDevice.isFDA,
  isIVDR: newDevice.isIVDR,
  components: newDevice.components.map(
    ({ index, collapsed, subComponents, ...component }) => ({
      ...component,
      subComponents: subComponents?.map(
        ({ index, ...subComponent }) => subComponent
      ),
    })
  ),
});
